export const DOMAIN = "https://sscodsdk.com";

export function urlParam(name) {
	return new URLSearchParams(window.location.search).get(name) || "";
}
